module.exports = __webpack_public_path__ + "img/5.1684dfb7.webp";